import React, { useEffect, useRef, useState } from "react";
import Style from "./style.module.css";

import { Alert, Skeleton, Snackbar } from "@mui/material";
import CompanySettingAddUpdate from "../../../modal";
import { useApiCall } from "../../../../../../component/custom-hooks/api-call";
import InnerLoader from "../../../../../../component/ui/loader/inner-loader";
import DataNotFound from "../../../../../../component/ui/loader/data-not-found";
import {
  Table,
  TableBody,
  TableCard,
  TableCell,
  TableFilterReturn,
  TableHead,
  TableHeaderWrap,
  TableRow,
} from "../../../../../../component/table/table-layout";
import DynamicFilter from "../../../../../../component/table/filter-table/dynamic-filter";
import CustomizeTabsPopup from "../../../../../../component/table/customize-table";
import LayoutTopIcon from "../../../../../../component/icons/layout-top";
import FilterFunnel01Icon from "../../../../../../component/icons/filter-funnel-01";
import Tooltip from "../../../../../../component/ui/tooltip";
import NewEditIcon from "../../../../../../component/icons/action-edit-icon";
import StatusChip from "../../../../../../component/ui/chip/status";
import ChevronDownIcon from "../../../../../../component/icons/chevron-down";

const SettingsTeams = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [apiData, setApiData] = useState([]);
  const [showModalFilterTable, setShowModalFilterTable] = useState(false);
  const [filterReturn, setFilterReturn] = useState([]);
  const [saveFilter, setSaveFilter] = useState([]);
  const [tablePagination, setTablePagination] = useState({});
  const [btnLoader, setBtnLoader] = useState(false);
  const [alertData, setAlertData] = useState({ isShow: false });

  const [showModalCustomizeTabs, setShowModalCustomizeTabs] = useState(false);
  const [tableHeader, setTableHeader] = useState([]);

  const [currentData, setCurrentData] = useState({});
  const [showEditModal, setShowEditModal] = useState(false);
  const [teams, setTeams] = useState([]);
  const [agents, setAgents] = useState([]);

  const handleClose = () => {
    setAlertData({ isShow: false });
  };

  const apiCall = useApiCall();

  useEffect(() => {
    getData({});
    getAgents();
  }, []);

  const getAgents = async (id) => {
    try {
      const res = await apiCall({
        method: "get",
        url: `users/agents-list`,
      });
      setAgents(res?.agents);
    } catch (error) {
      console.warn("Error : ", error);
    }
  };

  const getData = async ({ filter = filterReturn }) => {
    setIsLoading(true);
    const extraUrl =
      filter?.length > 0
        ? "?" +
          filter
            .map(
              (f) =>
                `${encodeURIComponent(f.name)}=${encodeURIComponent(f.value)}`
            )
            .join("&")
        : "";

    try {
      const res = await apiCall({
        method: "get",
        url: `teams/teams-list-settings${extraUrl}`,
      });

      setApiData(res?.data);
      setTeams(res?.data);

      setTableHeader(res?.applied_headers);
      setSaveFilter(res?.custom_filters);

      setIsLoading(false);
    } catch (error) {
      console.warn("Error : ", error);
    }
  };

  const onSuccess = (message) => {
    setAlertData({ isShow: true, type: "success", message: message });
    setShowEditModal(false);
    setCurrentData({});
    setSubProductModal(false);
    setSubProductData({});
    getData({});
  };

  const onError = (message) => {
    setAlertData({ isShow: true, type: "error", message: message });
  };

  const editTeam = (data) => {
    setCurrentData(data);
    setShowEditModal(true);
  };

  const filterModalData = [
    {
      name: "user_id",
      label: "User Name",
      options: ["is"],
      selectedOpt: "is",
      value: "",
      type: "dropdown",
      dropdown: agents,
      dropdownKey: "name",
      dropdownVal: "userid",
    },
    {
      name: "team_id",
      label: "Team Name",
      options: ["is"],
      selectedOpt: "is",
      value: "",
      type: "dropdown",
      dropdown: teams,
      dropdownKey: "team_name",
      dropdownVal: "team_id",
    },
    {
      name: "ttype",
      label: "Team Type",
      options: ["is"],
      selectedOpt: "is",
      value: "",
      type: "dropdown",
      dropdown: [
        { label: "Upsell", value: "Upsell" },
        { label: "Fresh", value: "Fresh" },
      ],
      dropdownKey: "label",
      dropdownVal: "value",
    },
  ];

  const [productPackages, setProductPackages] = useState([]);
  const [subProductModal, setSubProductModal] = useState(false);
  const [subProductData, setSubProductData] = useState({});
  const [spLoading, setSpLoading] = useState(false);

  const [openRow, setOpenRow] = useState("");
  const toggleRow = (id) => {
    if (id == openRow) {
      setOpenRow("");
      setProductPackages([]);
      return;
    }

    setOpenRow(id);
    getProductPackages(id);
  };

  const getProductPackages = async (id) => {
    setSpLoading(true);
    try {
      const res = await apiCall({
        method: "get",
        url: `teams/team-users/${id}`,
      });
      console.log("res", res);

      setProductPackages(res?.data?.users);
    } catch (error) {
      console.warn("Error : ", error);
    } finally {
      setSpLoading(false);
    }
  };

  const editTeamUser = (eachList) => {
    setSubProductData(eachList);
    setSubProductModal(true);
  };

  const tableRef = useRef(null);

  return (
    <>
      <div className={`${Style.mainBody} `}>
        <div className={Style.teamSpaceDashboard}>
          <div className={Style.teamSpaceDashboard_main}>
            <div className={Style.teamSpaceDashboard_body}>
              {/* HEADER */}
              <div className={Style.empDirectory_header}>
                <div className={Style.empDirectory_header_left}>
                  {/* filter div */}

                  <TableFilterReturn
                    filterReturn={filterReturn}
                    onChange={(allFilter) => {
                      setFilterReturn(allFilter);
                      getData({ filter: allFilter });
                    }}
                  />
                </div>

                <div className={Style.empDirectory_header_right}>
                  <div className={Style.bpfl_action}>
                    <Tooltip
                      className={Style.bpfl_actionItems}
                      content={"Table Filter"}
                      position={"left center"}
                    >
                      <div
                        className={`${Style.bpfl_actionBtn} ${
                          filterReturn?.length ? Style.active : null
                        }`}
                        onClick={() => {
                          setShowModalFilterTable(true);
                        }}
                      >
                        <div className={Style.icon}>
                          <FilterFunnel01Icon />
                        </div>
                      </div>
                    </Tooltip>

                    <Tooltip
                      className={`${Style.bpfl_actionItems}`}
                      content={"Customize Table"}
                      position={"left center"}
                    >
                      <div
                        className={`${Style.bpfl_actionBtn}`}
                        onClick={() => {
                          setShowModalCustomizeTabs(true);
                        }}
                      >
                        <div className={Style.icon}>
                          <LayoutTopIcon />
                        </div>
                      </div>
                    </Tooltip>
                  </div>
                </div>
              </div>

              {/* BODY */}
              <div className={Style.empDirectory_body}>
                {isLoading ? (
                  <InnerLoader />
                ) : !apiData?.length ? (
                  <div className="flex justify-center items-center w-full h-full">
                    <DataNotFound title={"Teams"} />
                  </div>
                ) : (
                  <>
                    <TableCard ref={tableRef}>
                      <Table>
                        <TableHead>
                          <TableRow className="!z-40">
                            <TableCell header sticky className="!z-30">
                              <TableHeaderWrap>
                                <span className="pl-[50px]">Teams Name</span>
                              </TableHeaderWrap>
                            </TableCell>

                            {tableHeader?.map((eachHead, index) =>
                              eachHead.is_visible === 1 &&
                              eachHead?.show == 1 ? (
                                <TableCell header key={index} className="!z-20">
                                  <TableHeaderWrap>
                                    <span>{eachHead?.value}</span>
                                  </TableHeaderWrap>
                                </TableCell>
                              ) : null
                            )}
                            <TableCell header className="!z-20">
                              <TableHeaderWrap>
                                <span className="pl-[50px]">Action</span>
                              </TableHeaderWrap>
                            </TableCell>
                          </TableRow>
                        </TableHead>

                        <TableBody>
                          {apiData?.map((eachList, index) => {
                            return (
                              <>
                                <TableRow key={`${index}`}>
                                  <TableCell sticky>
                                    <div
                                      className={`${Style.tableActionArea} !gap-4`}
                                    >
                                      <div className="flex items-center gap-3">
                                        <div className="font-medium leading-5 pl-[50px]">
                                          {eachList?.team_name}
                                        </div>
                                      </div>

                                      <div
                                        className={
                                          Style.tableActionAreaBtnGrpup
                                        }
                                      >
                                        <div
                                          className={
                                            "w-7 h-7 flex items-center justify-center rounded-md bg-[rgba()] shadow-[0_4px_12px_rgba(0,0,0,0.08)] border border-gray-100 hover:scale-105 transition-transform duration-300"
                                          }
                                          onClick={() => {
                                            editTeam(eachList);
                                          }}
                                        >
                                          <div
                                            className={Style.icon}
                                            style={{ color: "#FF9500" }}
                                          >
                                            <NewEditIcon className="h-4.5 w-4.5" />
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </TableCell>

                                  {tableHeader?.map((eachHead, i) =>
                                    eachHead.is_visible === 1 &&
                                    eachHead?.show == 1 ? (
                                      <>
                                        {eachHead.key === "status" ? (
                                          <TableCell
                                            key={`${i}-${index}`}
                                            className="text-center capitalize"
                                          >
                                            {eachList[eachHead.key] == "1" ? (
                                              <StatusChip color="green">
                                                {"Active" || "--"}
                                              </StatusChip>
                                            ) : (
                                              <StatusChip color="red">
                                                {"InActive" || "--"}
                                              </StatusChip>
                                            )}
                                          </TableCell>
                                        ) : eachHead.key === "team_users" ? (
                                          <TableCell
                                            key={`${i}-${index}`}
                                            className="text-center capitalize"
                                          >
                                            {eachList?.team_users?.name}
                                          </TableCell>
                                        ) : (
                                          <TableCell key={`${i}-${index}`}>
                                            {eachList[eachHead.key] ?? "--"}
                                          </TableCell>
                                        )}
                                      </>
                                    ) : null
                                  )}
                                  <TableCell>
                                    <button
                                      onClick={() => {
                                        toggleRow(eachList?.team_id);
                                      }}
                                      className={`
                                        flex items-center justify-between gap-2
                                        px-3 py-1.5
                                        bg-white hover:bg-white/50
                                        border border-gray-300
                                        rounded-md
                                        text-sm font-medium text-gray-700
                                        transition-all duration-300
                                      `}
                                    >
                                      <span className="flex items-start gap-1">
                                        Team Users
                                        <b className="text-gray-400 text-[10px]">
                                          ({eachList?.team_users_count})
                                        </b>
                                      </span>
                                      <div
                                        className={`${
                                          openRow == eachList.team_id
                                            ? // expandedRows == eachList?.team_id
                                              "rotate-180"
                                            : ""
                                        } transition-transform duration-300`}
                                      >
                                        <ChevronDownIcon className="h-4.5 w-4.5 text-gray-500" />
                                      </div>
                                    </button>
                                  </TableCell>
                                </TableRow>

                                {/* Drill Table */}
                                {openRow == eachList?.team_id && (
                                  // expandedRows == eachList?.id
                                  <TableRow
                                    key={`drill-${eachList?.team_id}`}
                                    className={`${Style.drillRow} !bg-[#F7F7F7] !pr-3`}
                                  >
                                    <TableCell
                                      colSpan={7}
                                      className={"!bg-[#F7F7F7]"}
                                    >
                                      {spLoading ? (
                                        <InnerLoader />
                                      ) : productPackages?.length ? (
                                        <div className="p-3 rounded-lg border border-gray-200 bg-white shadow-sm">
                                          <Table className="w-full border-collapse">
                                            <TableHead>
                                              <TableRow>
                                                <TableCell header>
                                                  <div className="pl-10">
                                                    Name
                                                  </div>
                                                </TableCell>
                                                <TableCell header>
                                                  Email
                                                </TableCell>
                                                <TableCell header>
                                                  Role
                                                </TableCell>
                                              </TableRow>
                                            </TableHead>
                                            <TableBody>
                                              {productPackages?.map((sp, i) => (
                                                <TableRow key={`${i}`}>
                                                  <TableCell sticky>
                                                    <div
                                                      className={`${Style.tableActionArea} !gap-4`}
                                                    >
                                                      <div className="flex items-center gap-3">
                                                        <div className="font-medium leading-5 pl-[50px]">
                                                          {sp?.name}
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </TableCell>
                                                  <TableCell key={`td-${i}`}>
                                                    {sp?.email ? (
                                                      <a
                                                        href={
                                                          `mailto:${sp?.email}` ||
                                                          ""
                                                        }
                                                      >
                                                        {sp?.email || "--"}
                                                      </a>
                                                    ) : (
                                                      "--"
                                                    )}
                                                  </TableCell>

                                                  <TableCell>
                                                    {sp.role_name ?? "--"}
                                                  </TableCell>
                                                </TableRow>
                                              ))}
                                            </TableBody>
                                          </Table>
                                        </div>
                                      ) : (
                                        <div className="w-full text-center flex justify-center items-center">
                                          <DataNotFound title={"Team Users"} />
                                        </div>
                                      )}
                                    </TableCell>
                                  </TableRow>
                                )}
                              </>
                            );
                          })}
                        </TableBody>
                      </Table>
                    </TableCard>
                  </>
                )}
              </div>

              {!isLoading ? (
                apiData?.length > 0 ? (
                  <div
                    className={Style.table_footer}
                    style={{ alignItems: "center" }}
                  >
                    <div className={Style.table_footer_left}>
                      {`showing 1 to ${apiData?.length} of ${
                        tablePagination?.total || apiData?.length
                      }`}
                    </div>

                    {tablePagination ? (
                      <div className={Style.empDirectory_footer}>
                        {tablePagination?.next_page_url ? (
                          <button
                            className={Style.loadMoreBtn}
                            onClick={() => {
                              if (btnLoader) return;
                              // setPageCount(pageCount + 1);
                              setBtnLoader(true);
                              // filterData({ page: pageCount + 1, btnCall: true });
                              getData({
                                page: tablePagination?.next_page_url,
                              });
                            }}
                          >
                            {btnLoader ? (
                              <InnerLoader
                                className={Style.loader}
                                textStatus={false}
                              />
                            ) : (
                              "Load More"
                            )}
                          </button>
                        ) : null}
                      </div>
                    ) : null}

                    <div
                      className={`${Style.table_footer_left} ${Style.rightText}`}
                    ></div>
                  </div>
                ) : null
              ) : (
                <div
                  className={Style.table_footer}
                  style={{ alignItems: "center" }}
                >
                  <div className={Style.table_footer_left}>
                    <Skeleton width={"50%"} height={15} />
                  </div>

                  <div className={Style.empDirectory_footer}>
                    <Skeleton width={"180px"} height={40} />
                  </div>

                  <div
                    className={`${Style.table_footer_left} ${Style.rightText}`}
                  ></div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {showEditModal && (
        <CompanySettingAddUpdate
          onClose={() => {
            setShowEditModal(false);
          }}
          data={currentData}
          onSubmit={onSuccess}
          onError={onError}
          tabIndex={6}
        />
      )}
      {subProductModal && (
        <CompanySettingAddUpdate
          onClose={() => {
            setSubProductModal(false);
          }}
          data={subProductData}
          onSubmit={onSuccess}
          onError={onError}
          tabIndex={7}
        />
      )}
      {showModalFilterTable && (
        <DynamicFilter
          data={filterModalData}
          onClose={() => setShowModalFilterTable(false)}
          returnData={filterReturn}
          onSave={(filters, filterName, editingFilter) => {
            getData({ filter: filters });
            setShowModalFilterTable(false);
            setFilterReturn(filters);
          }}
          saveFilter={saveFilter}
          apiUrl="teams/teams-list-settings"
        />
      )}

      {showModalCustomizeTabs && (
        <CustomizeTabsPopup
          data={tableHeader}
          onClose={() => {
            setShowModalCustomizeTabs(false);
            const table = tableRef?.current;
            if (table) {
              table.style.zIndex = 1;
            }
          }}
          onPreview={(updatedHeaders) => {
            setTableHeader(updatedHeaders);
            const table = tableRef?.current;
            table.style.zIndex = 100;
          }}
          onPreviewClose={() => {
            const table = tableRef?.current;
            table.style.zIndex = 1;
          }}
          onSave={(saveHeaders) => {
            setTableHeader(saveHeaders);
            const table = tableRef?.current;
            if (table) {
              table.style.zIndex = 1;
            }
          }}
          apiUrl="teams/teams-list-settings"
        />
      )}

      <Snackbar
        open={alertData?.isShow}
        autoHideDuration={3000}
        onClose={handleClose}
      >
        <Alert
          onClose={handleClose}
          severity={alertData?.type}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {alertData?.message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default SettingsTeams;
